<template>
  <div>
    <template v-if="user === 'Staff'">
      <div>
        <div class="row">
          <div class="col-12 text-center mb-3">
            <label>Entrega de información base</label>
          </div>
        </div>

        <div class="row flex align-items-center p-2 pointer justify-content-between">
          <div class="ml-3">
            <a :class="selectedComponent === 'DatosGenerales' ? 'active-menu' : 'text-menu'" @click="selected('DatosGenerales')">
              Datos de la Sociedad
            </a>
          </div>

          <div class="mr-3">
            <div :class="['circle', getSectionStatusColor('DatosGenerales')]">
              <span class="number">
                <i :class="['fa', getSectionStatusSymbol('DatosGenerales')]"></i>
              </span>
            </div>
          </div>
        </div>

        <div class="row flex align-items-center p-2 pointer justify-content-between">
          <div class="ml-3">
            <a :class="selectedComponent === 'DatosCapital' ? 'active-menu' : 'text-menu'" @click="selected('DatosCapital')">
              Capital y Accionistas
            </a>
          </div>

          <div class="mr-3">
            <div :class="['circle', getSectionStatusColor('DatosCapital')]">
              <span class="number">
                <i :class="['fa', getSectionStatusSymbol('DatosCapital')]"></i>
              </span>
            </div>
          </div>
        </div>

        <div class="row flex align-items-center p-2 pointer justify-content-between">
          <div class="ml-3">
            <a :class="selectedComponent === 'DatosOrganos' ? 'active-menu' : 'text-menu'" @click="selected('DatosOrganos')">
              Órganos Corporativos
            </a>
          </div>

          <div class="mr-3">
            <div :class="['circle', getSectionStatusColor('DatosOrganos')]">
              <span class="number">
                <i :class="['fa', getSectionStatusSymbol('DatosOrganos')]"></i>
              </span>
            </div>
          </div>
        </div>

        <div class="row flex align-items-center p-2 pointer justify-content-between">
          <div class="ml-3">
            <a
              :class="selectedComponent === 'RepresentantesYApoderados' ? 'active-menu' : 'text-menu'"
              @click="selected('RepresentantesYApoderados')"
            >
              Representantes
            </a>
          </div>

          <div class="mr-3">
            <div :class="['circle', getSectionStatusColor('RepresentantesYApoderados')]">
              <span class="number">
                <i :class="['fa', getSectionStatusSymbol('RepresentantesYApoderados')]"></i>
              </span>
            </div>
          </div>
        </div>

        <div class="row flex align-items-center p-2 pointer justify-content-between">
          <div class="ml-3">
            <a
              :class="selectedComponent === 'CapitulosEspeciales' ? 'active-menu' : 'text-menu'"
              @click="selected('CapitulosEspeciales')"
            >
              Capítulos especiales
            </a>
          </div>

          <div class="mr-3">
            <div :class="['circle', getSectionStatusColor('CapitulosEspeciales')]">
              <span class="number">
                <i :class="['fa', getSectionStatusSymbol('CapitulosEspeciales')]"></i>
              </span>
            </div>
          </div>
        </div>

        <div class="row flex align-items-center p-2 pointer justify-content-between">
          <div class="ml-3">
            <a
              :class="selectedComponent === 'EntidadFederativa' ? 'active-menu' : 'text-menu'"
              @click="selected('EntidadFederativa')"
            >
              Entidad Federativa firma
            </a>
          </div>

          <div class="mr-3">
            <div :class="['circle', getSectionStatusColor('EntidadFederativa')]">
              <span class="number">
                <i :class="['fa', getSectionStatusSymbol('EntidadFederativa')]"></i>
              </span>
            </div>
          </div>
        </div>

        <div class="row flex align-items-center p-2 pointer justify-content-between">
          <div class="ml-3">
            <a :class="selectedComponent === 'Cotizacion' ? 'active-menu' : 'text-menu'" @click="selected('Cotizacion')">
              Cotización y pago
            </a>
          </div>

          <div class="mr-3">
            <div :class="['circle', getSectionStatusColor('Cotizacion')]">
              <span class="number">
                <i :class="['fa', getSectionStatusSymbol('Cotizacion')]"></i>
              </span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 text-center my-3">
            <label>Complementa La Información</label>
          </div>
        </div>

        <div class="row flex align-items-center p-2 pointer justify-content-between">
          <div class="ml-3">
            <a :class="selectedComponent === 'Accionistas' ? 'active-menu' : 'text-menu'" @click="selected('Accionistas')">
              Accionistas
            </a>
          </div>

          <div class="mr-3">
            <div :class="['circle', getSectionStatusColor('Accionistas')]">
              <span class="number">
                <i :class="['fa', getSectionStatusSymbol('Accionistas')]"></i>
              </span>
            </div>
          </div>
        </div>

        <div class="row flex align-items-center p-2 pointer justify-content-between">
          <div class="ml-3">
            <a
              :class="selectedComponent === 'OrganosCorporativos' ? 'active-menu' : 'text-menu'"
              @click="selected('OrganosCorporativos')"
            >
              Órganos Corporativos
            </a>
          </div>

          <div class="mr-3">
            <div :class="['circle', getSectionStatusColor('OrganosCorporativos')]">
              <span class="number">
                <i :class="['fa', getSectionStatusSymbol('OrganosCorporativos')]"></i>
              </span>
            </div>
          </div>
        </div>

        <div class="row flex align-items-center p-2 pointer justify-content-between">
          <div class="ml-3">
            <a :class="selectedComponent === 'Apoderados' ? 'active-menu' : 'text-menu'" @click="selected('Apoderados')">
              Apoderados
            </a>
          </div>

          <div class="mr-3">
            <div :class="['circle', getSectionStatusColor('Apoderados')]">
              <span class="number">
                <i :class="['fa', getSectionStatusSymbol('Apoderados')]"></i>
              </span>
            </div>
          </div>
        </div>

        <div class="row flex align-items-center p-2 pointer justify-content-between">
          <div class="ml-3">
            <a
              :class="selectedComponent === 'BeneficiarioControlador' ? 'active-menu' : 'text-menu'"
              @click="selected('BeneficiarioControlador')"
            >
              Beneficiario Controlador
            </a>
          </div>

          <div class="mr-3">
            <div :class="['circle', getSectionStatusColor('BeneficiarioControlador')]">
              <span class="number">
                <i :class="['fa', getSectionStatusSymbol('BeneficiarioControlador')]"></i>
              </span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 text-center my-3">
            <label>Información Del Proceso</label>
          </div>
        </div>

        <div class="row flex align-items-center p-2 pointer justify-content-between">
          <div class="ml-3">
            <a
              :class="selectedComponent === 'DenominacionSocial' ? 'active-menu' : 'text-menu'"
              @click="selected('DenominacionSocial')"
            >
              Denominación social
            </a>
          </div>

          <div class="mr-3">
            <div :class="['circle', getSectionStatusColor('DenominacionSocial')]">
              <span class="number">
                <i :class="['fa', getSectionStatusSymbol('DenominacionSocial')]"></i>
              </span>
            </div>
          </div>
        </div>

        <div class="row flex align-items-center p-2 pointer justify-content-between">
          <div class="ml-3">
            <a :class="selectedComponent === 'DerechosRpc' ? 'active-menu' : 'text-menu'" @click="selected('DerechosRpc')">
              Derechos De Rpc
            </a>
          </div>

          <div class="mr-3">
            <div :class="['circle', getSectionStatusColor('DerechosRpc')]">
              <span class="number">
                <i :class="['fa', getSectionStatusSymbol('DerechosRpc')]"></i>
              </span>
            </div>
          </div>
        </div>

        <div class="row flex align-items-center p-2 pointer justify-content-between">
          <div class="ml-3">
            <a
              :class="selectedComponent === 'AsignarCorreduria' ? 'active-menu' : 'text-menu'"
              @click="selected('AsignarCorreduria')"
            >
              Asignar correduría
            </a>
          </div>

          <div class="mr-3">
            <div :class="['circle', constitutiva.corredurias_id && constitutiva.corredurias_id !== 17 ? 'completado' : '']">
              <span class="number">
                <i v-if="constitutiva.corredurias_id && constitutiva.corredurias_id !== 17" class="fa fa-check"></i>
                <i v-else class="fa fa-minus"></i>
              </span>
            </div>
          </div>
        </div>

        <div class="row flex align-items-center p-2 pointer justify-content-between">
          <div class="ml-3">
            <a
              :class="selectedComponent === 'GeneraDocumento' ? 'active-menu' : 'text-menu'"
              @click="selected('GeneraDocumento')"
            >
              Genera Documentos
            </a>
          </div>

          <div class="mr-3">
            <div :class="['circle', constitutiva.validoGenera ? 'completado' : '']">
              <span class="number">
                <i v-if="constitutiva.validoGenera" class="fa fa-check"></i>
                <i v-else class="fa fa-minus"></i>
              </span>
            </div>
          </div>
        </div>

        <div class="row flex align-items-center p-2 pointer justify-content-between">
          <div class="ml-3">
            <a :class="selectedComponent === 'DocFirmado' ? 'active-menu' : 'text-menu'" @click="selected('DocFirmado')">
              Documentos firmados digitalmente
            </a>
          </div>

          <div class="mr-3">
            <div :class="['circle', constitutiva.validoDocListo ? 'completado' : '']">
              <span class="number">
                <i v-if="constitutiva.validoDocListo" class="fa fa-check"></i>
                <i v-else class="fa fa-minus"></i>
              </span>
            </div>
          </div>
        </div>

        <div class="row flex align-items-center p-2 pointer justify-content-between">
          <div class="ml-3">
            <a :class="selectedComponent === 'CitaFirma' ? 'active-menu' : 'text-menu'" @click="selected('CitaFirma')">
              Agenda tu cita
            </a>
          </div>

          <div class="mr-3">
            <div :class="['circle', constitutiva.validoCita ? 'completado' : '']">
              <span class="number">
                <i v-if="constitutiva.validoCita" class="fa fa-check"></i>
                <i v-else class="fa fa-minus"></i>
              </span>
            </div>
          </div>
        </div>

        <div class="row flex align-items-center p-2 pointer justify-content-between">
          <div class="ml-3">
            <a :class="selectedComponent === 'Expediente' ? 'active-menu' : 'text-menu'" @click="selected('Expediente')">
              Expediente
            </a>
          </div>

          <div class="mr-3">
            <div :class="['circle', constitutiva.validoExpediente ? 'completado' : '']">
              <span class="number">
                <i v-if="constitutiva.validoExpediente" class="fa fa-check"></i>
                <i v-else class="fa fa-minus"></i>
              </span>
            </div>
          </div>
        </div>

        <div class="row flex align-items-center p-2 pointer justify-content-between">
          <div class="ml-3">
            <a :class="selectedComponent === 'Terminado' ? 'active-menu' : 'text-menu'" @click="selected('Terminado')">
              Terminado
            </a>
          </div>

          <div class="mr-3">
            <div :class="['circle', constitutiva.validoCita ? 'completado' : '']">
              <span class="number">
                <i v-if="constitutiva.validoCita" class="fa fa-check"></i>
                <i v-else class="fa fa-minus"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-else-if="user === 'Client'">
      <div>
        <div class="row">
          <div class="col-12 text-center mb-3">
            <label>Entrega de información base</label>
          </div>
        </div>

        <div class="row flex align-items-center p-2 pointer justify-content-between">
          <div class="ml-3">
            <a :class="selectedComponent === 'DatosGenerales' ? 'active-menu' : 'text-menu'" @click="selected('DatosGenerales')">
              Datos de la Sociedad
            </a>
          </div>

          <div class="mr-3">
            <div :class="['circle', getSectionStatusColor('DatosGenerales')]">
              <span class="number">
                <i :class="['fa', getSectionStatusSymbol('DatosGenerales')]"></i>
              </span>
            </div>
          </div>
        </div>

        <div class="row flex align-items-center p-2 pointer justify-content-between">
          <div class="ml-3">
            <a :class="selectedComponent === 'DatosCapital' ? 'active-menu' : 'text-menu'" @click="selected('DatosCapital')">
              Capital y Accionistas
            </a>
          </div>

          <div class="mr-3">
            <div :class="['circle', getSectionStatusColor('DatosCapital')]">
              <span class="number">
                <i :class="['fa', getSectionStatusSymbol('DatosCapital')]"></i>
              </span>
            </div>
          </div>
        </div>

        <div class="row flex align-items-center p-2 pointer justify-content-between">
          <div class="ml-3">
            <a :class="selectedComponent === 'DatosOrganos' ? 'active-menu' : 'text-menu'" @click="selected('DatosOrganos')">
              Órganos Corporativos
            </a>
          </div>

          <div class="mr-3">
            <div :class="['circle', getSectionStatusColor('DatosOrganos')]">
              <span class="number">
                <i :class="['fa', getSectionStatusSymbol('DatosOrganos')]"></i>
              </span>
            </div>
          </div>
        </div>

        <div class="row flex align-items-center p-2 pointer justify-content-between">
          <div class="ml-3">
            <a
              :class="selectedComponent === 'RepresentantesYApoderados' ? 'active-menu' : 'text-menu'"
              @click="selected('RepresentantesYApoderados')"
            >
              Representantes
            </a>
          </div>

          <div class="mr-3">
            <div :class="['circle', getSectionStatusColor('RepresentantesYApoderados')]">
              <span class="number">
                <i :class="['fa', getSectionStatusSymbol('RepresentantesYApoderados')]"></i>
              </span>
            </div>
          </div>
        </div>

        <div class="row flex align-items-center p-2 pointer justify-content-between">
          <div class="ml-3">
            <a
              :class="selectedComponent === 'CapitulosEspeciales' ? 'active-menu' : 'text-menu'"
              @click="selected('CapitulosEspeciales')"
            >
              Capítulos especiales
            </a>
          </div>

          <div class="mr-3">
            <div :class="['circle', getSectionStatusColor('CapitulosEspeciales')]">
              <span class="number">
                <i :class="['fa', getSectionStatusSymbol('CapitulosEspeciales')]"></i>
              </span>
            </div>
          </div>
        </div>

        <div class="row flex align-items-center p-2 pointer justify-content-between">
          <div class="ml-3">
            <a
              :class="selectedComponent === 'EntidadFederativa' ? 'active-menu' : 'text-menu'"
              @click="selected('EntidadFederativa')"
            >
              Entidad Federativa firma
            </a>
          </div>

          <div class="mr-3">
            <div :class="['circle', getSectionStatusColor('EntidadFederativa')]">
              <span class="number">
                <i :class="['fa', getSectionStatusSymbol('EntidadFederativa')]"></i>
              </span>
            </div>
          </div>
        </div>

        <div class="row flex align-items-center p-2 pointer justify-content-between">
          <div class="ml-3">
            <a :class="selectedComponent === 'Cotizacion' ? 'active-menu' : 'text-menu'" @click="selected('Cotizacion')">
              Cotización y pago
            </a>
          </div>

          <div class="mr-3">
            <div :class="['circle', getSectionStatusColor('Cotizacion')]">
              <span class="number">
                <i :class="['fa', getSectionStatusSymbol('Cotizacion')]"></i>
              </span>
            </div>
          </div>
        </div>

        <div class="row" v-if="toShowMenuItemComputed">
          <div class="col-12 text-center my-3">
            <label>Complementa la Información</label>
          </div>
        </div>

        <div class="row flex align-items-center p-2 pointer justify-content-between" v-if="toShowMenuItemComputed">
          <div class="ml-3">
            <a :class="selectedComponent === 'Accionistas' ? 'active-menu' : 'text-menu'" @click="selected('Accionistas')">
              Accionistas
            </a>
          </div>

          <div class="mr-3">
            <div :class="['circle', getSectionStatusColor('Accionistas')]">
              <span class="number">
                <i :class="['fa', getSectionStatusSymbol('Accionistas')]"></i>
              </span>
            </div>
          </div>
        </div>

        <div class="row flex align-items-center p-2 pointer justify-content-between" v-if="toShowMenuItemComputed">
          <div class="ml-3">
            <a
              :class="selectedComponent === 'OrganosCorporativos' ? 'active-menu' : 'text-menu'"
              @click="selected('OrganosCorporativos')"
            >
              Órganos Corporativos
            </a>
          </div>

          <div class="mr-3">
            <div :class="['circle', getSectionStatusColor('OrganosCorporativos')]">
              <span class="number">
                <i :class="['fa', getSectionStatusSymbol('OrganosCorporativos')]"></i>
              </span>
            </div>
          </div>
        </div>

        <div class="row flex align-items-center p-2 pointer justify-content-between" v-if="toShowMenuItemComputed">
          <div class="ml-3">
            <a :class="selectedComponent === 'Apoderados' ? 'active-menu' : 'text-menu'" @click="selected('Apoderados')">
              Apoderados
            </a>
          </div>

          <div class="mr-3">
            <div :class="['circle', getSectionStatusColor('Apoderados')]">
              <span class="number">
                <i :class="['fa', getSectionStatusSymbol('Apoderados')]"></i>
              </span>
            </div>
          </div>
        </div>

        <div class="row flex align-items-center p-2 pointer justify-content-between" v-if="toShowMenuItemComputed">
          <div class="ml-3">
            <a
              :class="selectedComponent === 'BeneficiarioControlador' ? 'active-menu' : 'text-menu'"
              @click="selected('BeneficiarioControlador')"
            >
              Beneficiario Controlador
            </a>
          </div>

          <div class="mr-3">
            <div :class="['circle', getSectionStatusColor('BeneficiarioControlador')]">
              <span class="number">
                <i :class="['fa', getSectionStatusSymbol('BeneficiarioControlador')]"></i>
              </span>
            </div>
          </div>
        </div>

        <div class="row" v-if="toShowInformacionDelProcesoMenuItemComputed">
          <div class="col-12 text-center my-3">
            <label>Información Del Proceso</label>
          </div>
        </div>

        <div
          class="row flex align-items-center p-2 pointer justify-content-between"
          v-if="toShowInformacionDelProcesoMenuItemComputed"
        >
          <div class="ml-3">
            <a :class="selectedComponent === 'DerechosRpc' ? 'active-menu' : 'text-menu'" @click="selected('DerechosRpc')">
              Derechos De Rpc
            </a>
          </div>

          <div class="mr-3">
            <div :class="['circle', constitutiva.validoDerechosRpc ? 'completado' : '']">
              <span class="number">
                <i v-if="constitutiva.validoDerechosRpc" class="fa fa-check"></i>
                <i v-else class="fa fa-minus"></i>
              </span>
            </div>
          </div>
        </div>

        <div
          class="row flex align-items-center p-2 pointer justify-content-between"
          v-if="toShowInformacionDelProcesoMenuItemComputed"
        >
          <div class="ml-3">
            <a :class="selectedComponent === 'CitaFirma' ? 'active-menu' : 'text-menu'" @click="selected('CitaFirma')">
              Agenda tu cita
            </a>
          </div>

          <div class="mr-3">
            <div :class="['circle', constitutiva.validoCita ? 'completado' : '']">
              <span class="number">
                <i v-if="constitutiva.validoCita" class="fa fa-check"></i>
                <i v-else class="fa fa-minus"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "TreeMenuConstitucionSociedades",

  props: {
    constitutiva: { type: Object },
    user: { type: String },
    selectedComponent: { type: String },
  },

  computed: {
    toShowMenuItemComputed() {
      if (this.user == "Staff"){
        return true;
      }

      return this.constitutiva.estatus_id && this.constitutiva.estatus_id != 1;
    },

    toShowInformacionDelProcesoMenuItemComputed() {
      if (this.user == "Staff"){
        return true;
      }

      return this.constitutiva.estatus_id != null && ![1, 2].includes(this.constitutiva.estatus_id);
    },
  },

  data: () => ({}),

  watch: {},

  methods: {
    getSectionStatusColor(section) {
      const formulario = this.constitutiva.formularios.find((f) => f.formulario === section);

      if (this.user == "Staff") {
        if (formulario?.valido) {
          return "completado";
        }
      } else if (this.user == "Client") {
        if (formulario?.guardado || formulario?.valido) {
          return "completado";
        }
      }

      return "";
    },

    getSectionStatusSymbol(section) {
      const formulario = this.constitutiva.formularios.find((f) => f.formulario === section);

      if (this.user == "Staff") {
        if (formulario?.valido) {
          return "fa-check";
        }
      } else if (this.user == "Client") {
        if (formulario?.guardado || formulario?.valido) {
          return "fa-check";
        }
      }

      return "fa-minus";
    },

    selected(node) {
      this.$emit("node", node);
    },
  },
};
</script>

<style scoped>
.completado {
  background-color: yellowgreen !important;
}

.number {
  font-size: 11px;
  color: white;
}
</style>
